import { Form, FormProps, Input, Select } from "antd";
import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomForm from "../../../components/common/CustomForm";
import AXIOS from "../../../helpers/api";
import { BASE_API } from "../../../helpers/apiUrl";
import {
  ArrayOption,
  pathLink,
  selectSearchOption,
} from "../../../helpers/siteConfig";
import AdminLayout from "../../../layouts/AdminLayout";
import {
  getAllAreaAsync,
  getAllRegionAsync,
  getAllTerritoryAsync,
} from "../../../store/features/NP/geoInfo/geoAPI";
import { createUserAsync } from "../../../store/features/NP/resource/resourceAPI";
import { getAllSupplierAsync } from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { UserData } from "../../../types/redux";
import { removeQuotes } from "../../../utils/string";

export default function ManageResource() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [selectRegion, setSelectRegion] = useState("");
  const [selectArea, setSelectArea] = useState("");
  const { regions, areas, territorys } = useAppSelector((state) => state.npGeo);
  const { postLoading } = useAppSelector((state) => state.resource);
  const { allSupplier } = useAppSelector((state) => state.supplier);
  const { login } = useAppSelector((state) => state.login);
  const location = useLocation();
  const path = pathLink(location.pathname, 1);
  const navLink = `/${path}/resource`;

  const onFinish: FormProps<UserData>["onFinish"] = (values) => {
    // lattitude, longitude,
    const { region, area, teritory, nid, ...rest } = values;

    const data = {
      ...rest,
      nid: String(nid),
      region,
      area,
      teritory,
      regionName: regions?.find((el) => el?._id === region)?.regionName || "",
      areaName: areas?.find((el) => el?._id === area)?.areaName || "",
      teritoryName:
        territorys?.find((el) => el?._id === teritory)?.teritoryName || "",
      isPG: true,
      lattitude: 23.7055748,
      longitude: 90.3621026,
      location: {
        type: "Point",
        coordinates: [90.3621026, 23.7055748],
      },
      // lattitude,
      // longitude,
      // location: {
      //   type: "Point",
      //   coordinates: [longitude, lattitude],
      // },
    };

    // return console.log(data);

    dispatch(
      createUserAsync({
        data,
        others: {
          reRender,
        },
      })
    );
  };

  // redirect and re-render function
  const reRender = (val: boolean) => {
    if (val) navigate(navLink);
  };

  const checkEmployeeExist = debounce(
    (employeeId: string, callback: (result: string) => void) => {
      AXIOS.post(BASE_API.checkEmployeeID, { employeeId, isPG: true })
        .then(() => callback(""))
        .catch((err) =>
          callback(
            removeQuotes(
              err?.response?.data?.message || "Employee ID already exists"
            )
          )
        );
    },
    500
  );

  const checkEmailExist = debounce(
    (email: string, callback: (result: string) => void) => {
      AXIOS.post(BASE_API.checkEmail, { email, isPG: true })
        .then(() => callback(""))
        .catch((err) =>
          callback(
            removeQuotes(err?.response?.data?.message || "Email already exists")
          )
        );
    },
    500
  );

  const checkPhoneExist = debounce(
    (phoneNumber: string, callback: (result: string) => void) => {
      AXIOS.post(BASE_API.checkPhone, { phoneNumber, isPG: true })
        .then(() => callback(""))
        .catch((err) =>
          callback(
            removeQuotes(
              err?.response?.data?.message || "Phone number already exist"
            )
          )
        );
    },
    500
  );

  const checkNIDExist = debounce(
    (nid: string, callback: (result: string) => void) => {
      AXIOS.post(BASE_API.checkNID, { nid: String(nid), isPG: true })
        .then(() => callback(""))
        .catch((err) =>
          callback(
            removeQuotes(err?.response?.data?.message || "NID already exists")
          )
        );
    },
    500
  );

  useEffect(() => {
    dispatch(getAllRegionAsync({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getAllAreaAsync({
        params: {
          region: selectRegion,
        },
      })
    );
  }, [dispatch, selectRegion]);

  useEffect(() => {
    dispatch(
      getAllTerritoryAsync({
        params: {
          area: selectArea,
        },
      })
    );
  }, [dispatch, selectArea]);

  useEffect(() => {
    dispatch(getAllSupplierAsync({}));
  }, [dispatch]);

  // console.log(
  //   allSupplier?.find((el) => el?._id === login?.suppler),
  //   login?.suppler
  // );

  useEffect(() => {
    if (
      path === "vendor" &&
      allSupplier?.find((el) => el?._id === login?.suppler)
    ) {
      form.setFieldsValue({
        suppler: login?.suppler || undefined,
      });
    }
  }, [allSupplier, form, login?.suppler, path]);

  useEffect(() => {
    if (login?.role === "region" || login?.role === "finance") {
      form.setFieldsValue({
        region: login?.region,
      });

      setSelectRegion(login?.region);
    }
  }, [form, login?.region, login?.role]);

  return (
    <AdminLayout title="Add PG Runner" headerTitle="PG Runner">
      <CustomForm<UserData>
        onFinish={onFinish}
        title="Add PG Runner"
        formTitle="Add PG Runner"
        backLink={navLink}
        disabled={postLoading}
        formProps={{
          form,
        }}
      >
        <Form.Item
          name="firstName"
          label="Operator First Name"
          rules={[
            {
              required: true,
              message: "Please enter operator first name",
            },
          ]}
        >
          <Input size="large" placeholder="Enter first name" />
        </Form.Item>
        <Form.Item
          name="lastName"
          label="Operator Last Name"
          rules={[
            {
              required: true,
              message: "Please enter operator last name",
            },
          ]}
        >
          <Input size="large" placeholder="Enter last name" />
        </Form.Item>

        <Form.Item
          name="phoneNumber"
          label="Contact Number"
          rules={[
            {
              required: true,
              message: "Please enter contact number",
            },
            {
              validator: async (_: any, value: string) => {
                if (!value) {
                  return Promise.resolve();
                }

                const phoneRegex = /^(\+88)?(01[3-9])[0-9]{8}$/;
                if (!phoneRegex.test(value)) {
                  return Promise.reject(
                    new Error("Please enter a valid Bangladeshi contact number")
                  );
                }

                return new Promise<void>((resolve, reject) => {
                  checkPhoneExist(value, (result: string) => {
                    if (result) {
                      reject(new Error(result));
                    } else {
                      resolve();
                    }
                  });
                });
              },
            },
          ]}
        >
          <Input prefix={"BD "} size="large" placeholder="Mobile No:" />
        </Form.Item>

        <Form.Item
          name="employeeId"
          label="Employee ID"
          rules={[
            {
              required: true,
              message: "Please enter employee ID",
            },
            {
              validator: async (_: any, value: string) => {
                if (!value) return Promise.resolve();

                const trimmedValue = value.trim();

                // Rule 1: No leading hyphen or underscore
                if (/^[-_]/.test(trimmedValue)) {
                  return Promise.reject(
                    new Error("Are not allowed start with '-' or '_'")
                  );
                }

                // Rule 2: No decimal points
                if (trimmedValue.includes(".")) {
                  return Promise.reject(
                    new Error("Decimal points are not allowed")
                  );
                }

                // Rule 3: No spaces
                if (/\s/.test(trimmedValue)) {
                  return Promise.reject(new Error("Spaces are not allowed"));
                }

                // Rule 4: Only allow alphanumeric characters, hyphens, and underscores
                if (!/^[a-zA-Z0-9_-]+$/.test(trimmedValue)) {
                  return Promise.reject(
                    new Error(
                      "Only alphabets, digits, hyphens (-), and underscores (_) are allowed."
                    )
                  );
                }

                return Promise.resolve();
              },
            },
          ]}
        >
          <Input size="large" placeholder="Enter Employee ID" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              message: "Please enter email",
            },
            {
              validator: async (_: any, value: string) => {
                if (!value) {
                  return Promise.resolve();
                }

                // Validates:
                // - Standard email structure
                // - No consecutive dots (..), dashes (--), or dot-dash/dash-dot (.-, -.)
                const emailRegex =
                  /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
                const consecutiveInvalidsRegex = /(\.\.|--|-\.)|(\.-)/;

                if (
                  !emailRegex.test(value) ||
                  consecutiveInvalidsRegex.test(value)
                ) {
                  return Promise.reject(
                    new Error(
                      "Please enter a valid email (no repeated or mixed special characters)"
                    )
                  );
                }

                return new Promise<void>((resolve, reject) => {
                  checkEmailExist(value, (result: string) => {
                    if (result) {
                      reject(new Error(result));
                    } else {
                      resolve();
                    }
                  });
                });
              },
            },
          ]}
        >
          <Input size="large" placeholder="Enter email" />
        </Form.Item>

        <Form.Item
          name="nid"
          label="NID"
          rules={[
            {
              required: true,
              message: "Please enter NID",
            },
            {
              validator: async (_: any, value: string) => {
                if (!value) {
                  return Promise.resolve();
                }

                if (!/^\d+$/.test(value)) {
                  return Promise.reject(new Error("NID must be number"));
                }

                if (value.length < 10) {
                  return Promise.reject(
                    new Error("NID should be minimum 10 digits")
                  );
                }

                if (value.length > 20) {
                  return Promise.reject(
                    new Error("NID should not exceed 20 digits")
                  );
                }

                return new Promise<void>((resolve, reject) => {
                  checkNIDExist(value, (result: string) => {
                    if (result) {
                      reject(new Error(result));
                    } else {
                      resolve();
                    }
                  });
                });
              },
            },
          ]}
        >
          <Input className="w-full" size="large" placeholder="Enter NID" />
        </Form.Item>

        <Form.Item
          name="suppler"
          label="Select Vendor"
          rules={[
            {
              required: true,
              message: "Please select vendor",
            },
          ]}
        >
          <Select
            placeholder="Select Vendor"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={ArrayOption(
              [...allSupplier].sort((a, b) =>
                a.supplierName.localeCompare(b.supplierName)
              ),
              "supplierName",
              "_id",
              true
            )}
            disabled={
              path === "vendor" &&
              allSupplier?.find((el) => el?._id === login?.suppler)
                ? true
                : false
            }
            onChange={(val) => {
              const selected = allSupplier?.find((el) => el?._id === val);
              const regionId = selected?.region?._id;

              if (regionId) {
                setSelectRegion(regionId);
                form.setFieldsValue({ region: regionId });
              }
            }}
          />
        </Form.Item>

        <Form.Item
          name="region"
          label="Select Cluster"
          rules={[
            {
              required: true,
              message: "Please select cluster",
            },
          ]}
        >
          <Select
            placeholder="Select cluster"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={ArrayOption(
              [...regions].sort((a, b) =>
                a.regionName.localeCompare(b.regionName)
              ),
              "regionName",
              "_id",
              true
            )}
            onChange={(val) => {
              setSelectRegion(val);
              setSelectArea("");
              form.setFieldValue("area", undefined);
              form.setFieldValue("teritory", undefined);
            }}

            // disabled={login?.role === "region" || login?.role === "finance"}
          />
        </Form.Item>
        <Form.Item
          name="area"
          label="Select Zonal"
          rules={[
            {
              required: true,
              message: "Please select zonal",
            },
          ]}
        >
          <Select
            placeholder="Select zonal"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={ArrayOption(
              [...areas].sort((a, b) => a.areaName.localeCompare(b.areaName)),
              "areaName",
              "_id",
              true
            )}
            onChange={(val) => {
              setSelectArea(val);
              form.setFieldValue("teritory", undefined);
            }}
            disabled={!selectRegion}
          />
        </Form.Item>
        <Form.Item
          name="teritory"
          label="Select Territory"
          rules={[
            {
              required: true,
              message: "Please select territory",
            },
          ]}
        >
          <Select
            placeholder="Select territory"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={ArrayOption(
              [...territorys].sort((a, b) =>
                a.teritoryName.localeCompare(b.teritoryName)
              ),
              "teritoryName",
              "_id",
              true
            )}
            disabled={!selectArea}
          />
        </Form.Item>

        <Form.Item
          name="role"
          label="Select Role"
          rules={[
            {
              required: true,
              message: "Please select role",
            },
          ]}
          initialValue={"pg"}
        >
          <Select
            placeholder="Select role"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={ArrayOption(roleData, "name", "value")}
          />
        </Form.Item>

        {/* <Form.Item
          name="lattitude"
          label="Latitude"
          rules={[
            {
              required: true,
              message: "Please enter latitude",
            },
            {
              type: "number",
              min: 0,
              message: "Latitude can't be negative",
            },
          ]}
        >
          <InputNumber
            className="w-full"
            size="large"
            placeholder="Enter latitude"
          />
        </Form.Item>

        <Form.Item
          name="longitude"
          label="Longitude"
          rules={[
            {
              required: true,
              message: "Please enter longitude",
            },
            {
              type: "number",
              min: 0,
              message: "Longitude can't be negative",
            },
          ]}
        >
          <InputNumber
            className="w-full"
            size="large"
            placeholder="Enter longitude"
          />
        </Form.Item> */}

        <Form.Item
          name="pass"
          label="Password"
          rules={[
            {
              required: true,
              message: "Please enter password",
            },
            {
              min: 9,
              message: "Password must be minimum 9 characters.",
            },
          ]}
        >
          <Input.Password
            // prefix={<PassKeyIcon />}
            size="large"
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item
          name="confirmPass"
          label="Confirm Password"
          rules={[
            {
              required: true,
              message: "Please enter confirm password",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("pass") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Password and Confirm password do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password size="large" placeholder="Confirm Password" />
        </Form.Item>
      </CustomForm>
    </AdminLayout>
  );
}

const roleData = [{ name: "PG", value: "pg" }];
